import { FilterValues } from "../../models/global/FilterTypes";
import { Project } from "../../models/Project";

export const getFilteredProjects = (
  projects: Project[],
  filters: FilterValues
): Project[] => {
  const {
    searchText,
    status,
    sortOrder,
    tags,
    year,
    month,
  } = filters;

  const normalizedSearch = searchText.trim().toLowerCase();

  return projects
    .filter(project => {
      if (!normalizedSearch) return true;

      const searchableFields = [
        project.code,
        project.author,
        project.description,
        project.contact?.address?.city,
        project.contact?.address?.street,
        project.contact?.address?.number,
        project.contact?.address?.zipCode,
        project.creationDate,
      ];

      return searchableFields.some(field => {
        if (!field) return false;

        if (field instanceof Date) {
          return field.toISOString().toLowerCase().includes(normalizedSearch);
        }

        return String(field).toLowerCase().includes(normalizedSearch);
      });
    })

    .filter(project =>
      status === "No Filter" ? true : project.status === status
    )

    .filter(project =>
      tags.length === 0
        ? true
        : tags.every(tagId =>
            project.tags?.some(t => t.id === tagId)
          )
    )

    .filter(project => {
      if (!year) return true;
      return new Date(project.creationDate).getFullYear().toString() === year;
    })

    .filter(project => {
      if (!month) return true;
      const projectMonth = String(
        new Date(project.creationDate).getMonth() + 1
      ).padStart(2, "0");
      return projectMonth === month;
    })

    .sort((a, b) => {
      const aTime = new Date(a.creationDate).getTime();
      const bTime = new Date(b.creationDate).getTime();
      return sortOrder === "asc" ? aTime - bTime : bTime - aTime;
    });
};